import { render } from "./CarbonView.vue?vue&type=template&id=6a0db44e&scoped=true"
import script from "./CarbonView.vue?vue&type=script&lang=js"
export * from "./CarbonView.vue?vue&type=script&lang=js"

import "./CarbonView.vue?vue&type=style&index=0&id=6a0db44e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a0db44e"]])

export default __exports__